import { RefObject } from 'react';
import Draggable from 'react-draggable';

import IconDropdown from '../icons/dropdown-up';

export interface TableHorizontalScrollProps {
  tableScrollWrapper: RefObject<HTMLDivElement | null>;
  tableScrollerRef: RefObject<HTMLDivElement | null>;
  onScrollButton: (direction: 'left' | 'right') => void;
  scrollThumbPosition: number;
  onDrag: (x: number) => void;
  onDragEnd: (x: number) => void;
  accessibleDragPosition: number;
  scrollBarThumbWidth: number;
}

export default function TableHorizontalScroll({
  tableScrollWrapper,
  tableScrollerRef,
  onScrollButton,
  scrollThumbPosition,
  onDrag,
  accessibleDragPosition,
  scrollBarThumbWidth,
  onDragEnd,
}: TableHorizontalScrollProps) {
  return (
    <div
      className={`table-scroller ${
        accessibleDragPosition === 0 ? 'table-scroller-hidden' : ''
      }`}
    >
      <button
        type="button"
        className="table-scroller-button table-scroller-button-left"
        onClick={() => onScrollButton('right')}
        tabIndex={-1}
        aria-label="Left"
      >
        <IconDropdown className="table-scroller-left" />
      </button>
      <div className="table-scroller-scroll-wrapper" ref={tableScrollWrapper}>
        <Draggable
          nodeRef={tableScrollerRef}
          axis="x"
          position={{ x: -scrollThumbPosition, y: 0 }}
          onDrag={(e, data) => onDrag(data.x)}
          bounds={{
            left: 0,
            top: 0,
            right: accessibleDragPosition,
            bottom: 0,
          }}
          onStop={(e, data) => onDragEnd(data.x)}
        >
          <div
            ref={tableScrollerRef}
            className="table-scroller-scroll-progress"
            style={{
              width: `${scrollBarThumbWidth}px`,
            }}
          />
        </Draggable>
      </div>
      <button
        type="button"
        className="table-scroller-button table-scroller-button-right"
        onClick={() => onScrollButton('left')}
        tabIndex={-1}
        aria-label="Right"
      >
        <IconDropdown className="table-scroller-right" />
      </button>
    </div>
  );
}
